// Fix Bootstrap Icons font paths dynamically
export function fixBootstrapIconsPaths() {
  // Check if we're in production (deployed under /dev/)
  const isProduction = window.location.pathname.startsWith('/dev');
  
  if (isProduction) {
    // Create a style element to override font paths
    const style = document.createElement('style');
    style.textContent = `
      @font-face {
        font-display: swap;
        font-family: "bootstrap-icons";
        src: url("/dev/fonts/bootstrap-icons.woff2") format("woff2"),
             url("/dev/fonts/bootstrap-icons.woff") format("woff");
      }
    `;
    
    // Add high priority to override default styles
    style.setAttribute('data-bootstrap-icons-fix', 'true');
    
    // Insert at the beginning of head to ensure it loads early but can be overridden
    const firstStyleOrLink = document.head.querySelector('style, link[rel="stylesheet"]');
    if (firstStyleOrLink) {
      document.head.insertBefore(style, firstStyleOrLink.nextSibling);
    } else {
      document.head.appendChild(style);
    }
    
    console.log('Bootstrap Icons paths fixed for production');
  }
}

// Also ensure fonts are copied to the right location
export function ensureFontsAvailable() {
  // This function checks if fonts are accessible
  const testFont = () => {
    if (document.fonts && document.fonts.check) {
      const fontLoaded = document.fonts.check('1em bootstrap-icons');
      if (!fontLoaded) {
        console.warn('Bootstrap Icons font not loaded yet');
        // Try to force load by creating a test element
        const testEl = document.createElement('i');
        testEl.className = 'bi bi-check';
        testEl.style.cssText = 'position: absolute; left: -9999px; visibility: hidden;';
        document.body.appendChild(testEl);
        
        setTimeout(() => {
          if (testEl.parentNode) {
            testEl.parentNode.removeChild(testEl);
          }
        }, 100);
      }
    }
  };
  
  // Check immediately and after a delay
  testFont();
  setTimeout(testFont, 1000);
}